import type { Me } from '~/core/api'

/**
 * The signed-in person, in the shape the Agent's readers were written against.
 *
 * It is the panel's `Me` and nothing else: the Agent no longer asks the server
 * who is signed in, so there is no second answer for this to disagree with.
 */
export type AppSession = {
  user: {
    id: string
    email: string
    locale?: string
    name?: string | null
    image?: string | null
  } | null
  session?: {
    userId?: string
  }
} | null

export function sessionOf(me: Me | null | undefined): AppSession {
  if (!me) return null
  const { id, email, name, locale } = me.user
  return { user: { id, email, name, locale, image: null }, session: { userId: id } }
}
